import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import H3Text from '@Uilib/h3Text';
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';
import Helpers from '@Apis/helpers';
import SelectAppUser from '../../../../Common/SelectAppUser';

const ViewConsumptionDetails = ({
  selectedInvoice,
  quickUpdateInvoice,
  getActivityLog,
  getInvoiceById,
  user,
  consumptionId,
}) => {
  const [updateAccountManager, setUpdateAccountManager] = useState(selectedInvoice?.account_manager_id || null);

  const handleAccountManagerChange = (value) => {
    setUpdateAccountManager(value);
    quickUpdateInvoice(
      {
        account_manager_id: value || null,
        invoice_id: selectedInvoice.invoice_id,
      },
      () => {
        getActivityLog(selectedInvoice.invoice_id, 'consumption_order', 1, 10);
      }
    );
  };

  return (
    <div className="document-header">
      <div className="ant-row">
        <div className="ant-col-md-24">
          <H3Text
            text={(
              <span>
                <UserOutlined />
                {' '}
                <span>{`${selectedInvoice?.internal_cust_code} - ${selectedInvoice?.customer_info?.customer_name}`}</span>
              </span>
            )}
            className="document-header__party-name"
          />
        </div>
        {(selectedInvoice?.sales_order_number && selectedInvoice?.order_type == 'ANNUAL_MAINTENANCE_CONTRACT' && Helpers.getPermission(Helpers.permissionEntities.ANNUAL_MAINTENANCE_CONTRACT, Helpers.permissionTypes.READ, user)) && (
          <div className="ant-col-md-12">

            <div className="document-header__field">
              <H3Text text="AMC #" className="document-header__field-name" />

              <H3Text text={
                <Link to={`/sales/amc-sales-order/view/${selectedInvoice?.order_id}`} target="_blank">
                  {selectedInvoice?.sales_order_number || '-'}
                </Link>
              } className="document-header__field-value" />
            </div>
          </div>
        )}
        <div className="ant-col-md-12">
          <Tooltip title={selectedInvoice?.tenant_info?.tenant_name}>
            <div className="document-header__field">
              <H3Text text="Location" className="document-header__field-name" />
              <H3Text
                text={
                  selectedInvoice?.tenant_info?.tenant_name?.length > 25
                    ? `${selectedInvoice?.tenant_info?.tenant_name?.slice(0, 25)}...`
                    : selectedInvoice?.tenant_info?.tenant_name
                }
                className="document-header__field-value"
              />
            </div>
          </Tooltip>
        </div>

        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="Department" className="document-header__field-name" />
            <H3Text
              text={selectedInvoice?.tenant_department_info?.department_name}
              className="document-header__field-value"
            />
          </div>
        </div>

        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="Order Date" className="document-header__field-name" />
            <H3Text
              text={
                selectedInvoice?.invoice_date
                  ? dayjs(selectedInvoice.invoice_date).format('DD/MM/YYYY')
                  : '-'
              }
              className="document-header__field-value"
            />
          </div>
        </div>

        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="GSTIN" className="document-header__field-name" />
            <H3Text
              text={selectedInvoice?.customer_info?.gst_number ?? '-'}
              className="document-header__field-value"
            />
          </div>
        </div>

        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="Sales Manager" className="document-header__field-name" />
            <SelectAppUser
              hideTitle
              selectedUser={updateAccountManager}
              onChange={handleAccountManagerChange}
              disabled
              containerClassName="document-header__field-input"
            />
          </div>
        </div>

        <div className="ant-col-md-12">
          <div className="document-header__field">
            <H3Text text="Remarks" className="document-header__field-name" />
            <H3Text
              text={selectedInvoice?.internal_remarks ?? '-'}
              className="document-header__field-value"
            />
          </div>
        </div>

        {selectedInvoice?.custom_fields?.length > 0 && (
          <ViewCustomFields
            customFields={selectedInvoice.custom_fields.filter((cf) => cf.is_active)}
            wrapperClass="document-header__field"
            labelClass="document-header__field-name"
            valueClass="document-header__field-value"
            inputClassName="document-header__field-input"
            isHorizontal
            isEditable={false}
            handleCustomFieldUpdate={quickUpdateInvoice}
            entityId={selectedInvoice.invoice_id}
            callback={() =>
              getInvoiceById(
                user?.tenant_info?.org_id,
                Helpers.getTenantEntityPermission(
                  user?.user_tenants,
                  Helpers.permissionEntities.INVOICE,
                  Helpers.permissionTypes.READ
                ).join(',') || user?.tenant_info?.tenant_id,
                consumptionId
              )
            }
            entityName="order_id"
            entityType="CONSUMPTION_ORDER"
          />
        )}
      </div>
    </div>
  );
};

export default ViewConsumptionDetails;
